module.exports = __webpack_public_path__ + "static/img/guoqi2.138fd67.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/guoqi2.png
// module id = MHf5
// module chunks = 1